import { faCheck, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import React, { useMemo } from "react";
import styled from "styled-components";
import Button from "./Button";

const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const DayContainer = styled.div<{ color: string }>`
    margin: 0.5em;
    /* border: 2px solid #0002; */
    background: ${(props) => props.color};
    padding: 1em;
    border-radius: 1em;
    display: inline-flex;
    flex-grow: 1;
    flex-direction: column;
    max-width: 250px;
`;

export type TimeTableProps = {
    dates: Date[];
    className?: string;
    minDate?: Date;
    selected?: Date;
    buttonColor?: string;
    buttonIcon?: IconDefinition;
    readOnly?: boolean;
    style?: React.CSSProperties;
    onSelect?: (date: Date) => void;
    renderButtonContent?: (date: Date) => React.ReactNode;
};

export function TimeTable(props: TimeTableProps) {
    const days = useMemo(
        () =>
            props.dates
                .sort((a, b) => a.getTime() - b.getTime())
                .reduce((acc, e) => {
                    let key = new Date(e.getFullYear(), e.getMonth(), e.getDate()).toString();
                    if (acc[key]) acc[key].push(e);
                    else acc[key] = [e];
                    return acc;
                }, {} as { [d: string]: Date[] }),
        [props.dates]
    );
    return (
        <Container className={props.className} style={props.style}>
            {Object.keys(days).map((dayString) => {
                let day = new Date(dayString);
                let selected =
                    props.selected &&
                    props.selected.getFullYear() === day.getFullYear() &&
                    props.selected.getMonth() === day.getMonth() &&
                    props.selected.getDate() === day.getDate();
                return (
                    <DayContainer key={day.getTime()} color={selected ? "#56a44f55" : "#0001"}>
                        <h3>Op {day.toLocaleDateString()} om...</h3>
                        {days[dayString].map((time, i) => {
                            let selected = props.selected?.getTime() === time.getTime();
                            return (
                                <Button
                                    key={time.getTime()}
                                    style={{ fontSize: "0.8em", margin: "0.2em 0" }}
                                    disabled={
                                        props.readOnly || (props.minDate && time.getTime() < props.minDate.getTime())
                                    }
                                    color={selected ? "#56a44f" : props.buttonColor}
                                    icon={selected ? faCheck : props.buttonIcon}
                                    type="button"
                                    // active={selected}
                                    onClick={() => props.onSelect?.(time)}
                                >
                                    {props.renderButtonContent
                                        ? props.renderButtonContent(time)
                                        : time.toLocaleTimeString()}
                                </Button>
                            );
                        })}
                    </DayContainer>
                );
            })}
        </Container>
    );
}
